import { render, staticRenderFns } from "./TestChecklist.vue?vue&type=template&id=18d0fd10&scoped=true"
import script from "./TestChecklist.vue?vue&type=script&lang=js"
export * from "./TestChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0fd10",
  null
  
)

export default component.exports